import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EventsService, PaymentV2Service, VariablesService, VwoService } from '../../shared/services';
import { IPaymentSipConfig } from '../payment-sip/payment-sip.model';

@Component({
  selector: 'app-payment-sip-options',
  templateUrl: './payment-sip-options.component.html',
  styleUrls: ['./payment-sip-options.component.scss']
})
export class PaymentSipOptionsComponent implements OnInit {

  @Input() config: IPaymentSipConfig;
  @Output() dataEmit = new EventEmitter();
  @Output() paySwitchEmit = new EventEmitter();
  showIntent = false;

  selectedBank: any;

  constructor(
    public paymentV2: PaymentV2Service,
    public location: Location,
    private events: EventsService,
    public vars: VariablesService,
    public vwo: VwoService
  ) { }

  ngOnInit() {
  }

  selectOpTab(tab) {
    if (!tab?.index || tab?.index < 0) {
      tab.index = 0;
    }
    this.config.selectedTab = this.config.visibleTabs[tab?.index];
    this.paymentV2.paymentConfig.next({ selectedTab: this.config.selectedTab });
  }

  back() {
    if (this.vars?.pageName?.match('impact_portfolio_stories')) {
      this.showIntent = !this.showIntent;
    } else {
      this.location.back();
    }
    this.events.sendSystemEvent({ eventName: 'sip_payment_back' }).subscribe(_ => _);
  }

  popupshow = (event) => {
    this.showIntent = event;
  }
}
